export default __webpack_public_path__ + "7947224e8a9914fa332b16515176ce0d.woff";